const PRODUCT_INFO_STICKY_TOP_PROPERTY = '--redesign-product-sticky-top'

export default class RedesignProductStickyInfo {
  constructor (el) {
    this.el = el
    this.column = el.closest('.redesign-product__info')
    this.container = el.closest('.redesign-product__inner')
    this.gallery = this.container?.querySelector('.redesign-product__media')
    this.frame = null
    this.resizeObserver = null
    this.tabletQuery = window.matchMedia('(min-width: 768px)')

    this.requestUpdate = this.requestUpdate.bind(this)
    this.update = this.update.bind(this)

    this.init()
  }

  init () {
    this.update()

    if (typeof window.ResizeObserver === 'function') {
      this.resizeObserver = new window.ResizeObserver(this.requestUpdate)
      this.resizeObserver.observe(this.el)

      if (this.gallery) {
        this.resizeObserver.observe(this.gallery)
      }
    }

    window.addEventListener('load', this.requestUpdate)
    window.addEventListener('resize', this.requestUpdate)
  }

  requestUpdate () {
    if (this.frame) return

    this.frame = window.requestAnimationFrame(this.update)
  }

  update () {
    this.frame = null

    if (!this.tabletQuery.matches || !this.column || !this.gallery) {
      this.reset()
      return
    }

    const scrollTop = Math.max(
      window.scrollY || 0,
      document.documentElement.scrollTop || 0,
      document.body.scrollTop || 0
    )
    const stickyTop = this.column.getBoundingClientRect().top + scrollTop
    const infoHeight = this.el.getBoundingClientRect().height
    const galleryHeight = this.gallery.getBoundingClientRect().height
    const viewportHeight = document.documentElement.clientHeight || window.innerHeight
    const releaseSpace = Math.max(0, stickyTop + infoHeight - viewportHeight)

    this.el.style.setProperty(
      PRODUCT_INFO_STICKY_TOP_PROPERTY,
      `${stickyTop.toFixed(2)}px`
    )
    this.column.style.minHeight = `${(galleryHeight + releaseSpace).toFixed(2)}px`
  }

  reset () {
    this.el.style.removeProperty(PRODUCT_INFO_STICKY_TOP_PROPERTY)

    if (this.column) {
      this.column.style.removeProperty('min-height')
    }
  }

  destroy () {
    if (this.frame) {
      window.cancelAnimationFrame(this.frame)
      this.frame = null
    }

    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }

    window.removeEventListener('load', this.requestUpdate)
    window.removeEventListener('resize', this.requestUpdate)
    this.reset()
  }
}
